import React, { useEffect, useState } from "react";
import "../styles-quality-control/qa_style.css";
import "../styles-quality-control/styles.css";
import { Container, Grid, TextField, Typography } from "@mui/material";
import ModelName from "../modelName/modelName";
import ReworkSummary from "./reworkSummary";
import CaptureChassisNo from "../ChassisNoFromCamera/ChassisNoFromCamera";
import { useLocation } from "react-router-dom";
import { useChassis } from "../ChassisNoProvider/ChassisProvider";

const ReworkSummaryPage: React.FC = () => {
  const { chassisNo, setChassisNo, canAutoSetChassisNo } = useChassis();
  const [localChassisNo, setLocalChassisNo] = useState<string>(chassisNo || "");
  const [debouncedChassisNo, setDebouncedChassisNo] = useState<string>("");
  const [model, setModel] = useState<string>("");
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const queryChassisNo = params.get("chassisNo");
    if (queryChassisNo && canAutoSetChassisNo) {
      setChassisNo(queryChassisNo);
      setLocalChassisNo(queryChassisNo);
    } else if (!canAutoSetChassisNo) {
      setChassisNo("");
      setLocalChassisNo("");
    }
  }, [location.search, setChassisNo, canAutoSetChassisNo]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedChassisNo(localChassisNo);
    }, 2000);

    return () => clearTimeout(timer);
  }, [localChassisNo]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalChassisNo(e.target.value);
    if (canAutoSetChassisNo) {
      setChassisNo(e.target.value);
    }
  };

  const handleUploadComplete = (data: { chassisNo: string }) => {
    setLocalChassisNo(data.chassisNo);
    if (canAutoSetChassisNo) {
      setChassisNo(data.chassisNo);
    }
  };

  return (
    <Container sx={{ mt: 2, mb: 3 }}>
      <Typography variant="h4" gutterBottom>
        Rework Summary
      </Typography>
      <Grid container spacing={1} alignItems="center" sx={{ mb: 2 }}>
        <Grid
          item
          md={3}
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <CaptureChassisNo onUploadComplete={handleUploadComplete} />
          </div>

          <TextField
            label="Chassis No"
            variant="filled"
            size="small"
            value={localChassisNo}
            onChange={handleInputChange}
            sx={{
              "& .MuiInputLabel-root": {
                fontWeight: "bold",
                color: "#1976d2 !important",
              },
              "& .MuiInputBase-input": {
                color: "#1976d2 !important",
                opacity: "1 !important",
                "&[disabled]": {
                  color: "rgba(25, 118, 210, 1) !important",
                },
                fontSize: "20px",
              },
              flexGrow: 1,
              minWidth: "120px",
            }}
          />
        </Grid>

        <Grid item md={9} sx={{ display: "flex", alignItems: "center" }}>
          <ModelName model={model} />
        </Grid>
      </Grid>

      <ReworkSummary
        chassisNo={debouncedChassisNo}
        model={model}
        setModel={setModel}
      />
    </Container>
  );
};

export default ReworkSummaryPage;
